import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from "./router";
import store from "./store";

declare var Session: any;
declare var SessionUtils: any;


Session.ShowWaiting();

/////////////////////////////////////////////////////////////////////////////
// Summary :
//
/////////////////////////////////////////////////////////////////////////////
function WaitForSession() {

    if (Session.IsSessionLoaded() == false) {

        if (Session.RetryCount < 10) {

            setTimeout(function () {

                WaitForSession();

            }, 500);
        }

        return;
    }

    Session.RetryCount = 0;

    WaitForArticles();
}


/////////////////////////////////////////////////////////////////////////////
// Summary :
//
/////////////////////////////////////////////////////////////////////////////
function WaitForArticles() {

    if (window.sessionStorage.getItem("ArticleViewModels") == null) {

        if (Session.RetryCount < 10) {

            setTimeout(function () {

                WaitForArticles();

            }, 500);
        }

        return;
    }

    Vue.config.productionTip = false;

    new Vue({
        vuetify,
        router,
        render: (h) => h(App),
        beforeCreate(): void {
            store.dispatch("initialiseStore");
        },
    }).$mount('#app');


    Vue.filter("translate", function name(...strings: string[]): string {

        if (strings.length > 0) {

            return SessionUtils.GetTranslation("CONTROL_LABEL", strings[0], strings[1]);
        }

        return "";
    });

    Vue.filter("formatPrice", function name(value): string {

        return SessionUtils.FormatTo2DecimalPlaces(value);
    });

    Vue.filter('splitNumber', function (value) {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    });
}


WaitForSession();
